import { render, staticRenderFns } from "./fwsed-firm-detail.vue?vue&type=template&id=3f5788c6&scoped=true&"
import script from "./fwsed-firm-detail.vue?vue&type=script&lang=js&"
export * from "./fwsed-firm-detail.vue?vue&type=script&lang=js&"
import style0 from "./fwsed-firm-detail.vue?vue&type=style&index=0&id=3f5788c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5788c6",
  null
  
)

export default component.exports